// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"6afe2708","453":"a3e6556e"}[chunkId] + ".chunk.js";
};